import * as React from 'react';
import { FC } from 'react';

import { useTheme } from 'styled-components';

import { Icon } from '../icon';

import { RewardsChipContainer, RewardsChipText } from './rewards-chip.styled';
import { RewardsChipProps } from './types';

const RewardsChip: FC<RewardsChipProps> = ({
  children,
  rewardsLocked,
  'data-testid': dataTestId,
  'aria-label': ariaLabel,
}) => {
  const { token } = useTheme();
  return (
    <RewardsChipContainer
      $rewardsLocked={rewardsLocked}
      data-testid={dataTestId}
      aria-label={ariaLabel}
    >
      {rewardsLocked ? (
        <Icon
          icon="lock"
          color="icon-default"
          aria-hidden
          width={token('width-icon-small')}
          height={token('height-icon-small')}
          data-testid="lock-icon"
        />
      ) : (
        <Icon
          icon="rewards"
          color="icon-reversed"
          aria-hidden
          width={token('width-icon-small')}
          height={token('height-icon-small')}
          data-testid="rewards-icon"
        />
      )}
      <RewardsChipText>{children}</RewardsChipText>
    </RewardsChipContainer>
  );
};

export default RewardsChip;
